
import { PricePeriods } from "../contants";
import { PageRequest } from "../requests";
import { StatementDateFilterRequest } from "@/lib/requests/index";
import { BaseUrls } from "./BaseUrls";
import { objectToQueryString } from "./QueryParamsHelper";
const ACCOUNT_INCLUDES = "include=person_data,account,address,channels,country,new_inbox_message_count,new_support_ticket_answer_count,products,product_specs,kyc_details";
const DEPOT_INCLUDES = "depot_status,depot_status_history,depot_orders,depot_agio_transactions,account,interval,depot_histories";
const SINGLE_SUPPORT_TICKET_INCLUDE = "include=messages,creater,owner,contacts,support_status,person_data"
export class Urls{
    private static instance:Urls;
    public static URLS():Urls{
       
        if (!Urls.instance) {
            Urls.instance = new Urls();
        }

        return Urls.instance;
    }
    public getCountries(isCode:Boolean):string{
        return BaseUrls.getCoreUrl() + 'countries'+(isCode?"?order_by=alpha2_code&per_page=500":'?per_page=500');
    }
    public getPlanUrl(country_id?:Number):string{
        if(country_id)
        {
            return BaseUrls.getCoreUrl() + `pricing?country_id=${country_id}`;
        }
        else{
            return BaseUrls.getCoreUrl() + 'pricing';
        }
    }
    public sendEmailCode():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'email-code');
    }
    public verifyEmail():string
    {
        return this.buildUrl(BaseUrls.getCoreUrl(),'verify-email')
    }
    public sendSmsCode():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'send-sms');
    }
    public verifyPhoneNumber():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'verify-phone');
    }
    public termsAndConditions(conditionType:string,country?:number):string{
        let path = '';
        if(country){
            path = `conditions?country_id=${country}&condition_type_prerequisite=${conditionType}&per_page=500`;
        }
        else{
            path = `conditions?condition_type_prerequisite=${conditionType}&per_page=500`
        }
        return this.buildUrl(BaseUrls.getCoreUrl(),path)
    }
    public registerCustomer():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'register');
    }
    public resetPassword():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'password-reset/apply');
    }
    public verfiyResetPasswordToken():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'password-reset/check');
    }
    public resetPin():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'accounts/pin-reset');
    }
    public login():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'authenticate?'+ACCOUNT_INCLUDES);
    }
    public verifyMfa():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'mfa/login/verify?' + ACCOUNT_INCLUDES);
    }
    public getProfileUrl(id:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`contacts/${id}?${ACCOUNT_INCLUDES}`);
    }
    public getAssetsUrl(accountId:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`assets/${accountId}`);
    }
    public getLastTransactionUrl(accountId:number,page:number,per_page:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`accounts/${accountId}/latest-transactions?include=order_transactions,orders_payment_transactions&page=${page}&per_page=${per_page}`);
    }
    public getDepotListUrl(depotTypeId?:number,page:number = 1,perPage:number = 100):string{
        let url =  `depots/account-depots?include=${DEPOT_INCLUDES}&page=${page}&per_page=${perPage}`;
        if(depotTypeId){
            url += `&depot_type_id=${depotTypeId}`;
        }
        return  this.buildUrl(BaseUrls.getGoldDinarUrl(),url);
    }
    public getGoldPrice(currency:string):string {
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'current-gold-price?currency='+currency);
    }
    public getSilverPrice(currency:string):string {
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'current-silver-price?currency='+currency);
    }
    public getPlatinumPrice(currency:string):string {
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'current-platinum-price?currency='+currency);
    }
    public getPalladiumPrice(currency:string):string {
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'current-palladium-price?currency='+currency);
    }
    public getDepotTypesUrl(){
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'depot-types');
    }
    public getGoldPriceVariationData(period:string,currency:string){
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`historical-price?type=${period}&currency=${currency}`);
    }
    public getSilverPriceVariationData(period:string,currency:string){
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`silver-price-historical?period=${period}&currency=${currency}`);
    }
    public getPlatinumPriceVariationData(period:string,currency:string){
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`platinum-price-historical?period=${period}&currency=${currency}`);
    }
    public getPalladiumPriceVariationData(period:string,currency:string){
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`palladium-price-historical?period=${period}&currency=${currency}`);
    }
    public requestPassword():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),'password-reset/request');
    }
    public depotDetail(id:number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`depots/${id}?include=${DEPOT_INCLUDES}`);
    }
    public depotHistoryValue(depot_id:number,period:string):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`depots/${depot_id}/history?period=${period}`);
    }
    public getDepotOrders(depot_id:number,request:PageRequest):string{
        const queryParams = objectToQueryString(request);
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`orders/depot-orders/${depot_id}?include=order_transactions,orders_payment_transactions,payment_details&${queryParams}`);
    }
    public getDepotOrderStament(depot_id:number, request: StatementDateFilterRequest):string{
        const queryParams = objectToQueryString(request);
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`depots/${depot_id}/statement?${queryParams}`);
    }
    public getSavingPlanTarget():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'target-types');
    }
    public addDepot():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'depots');
    }
    public accountPorductDetails(id:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`accounts/${id}/product-fees`);
    }
    public getClientPaymentAccounts():string{
        return this.buildUrl(BaseUrls.getPaymentUrl(),'payment-account/user-accounts');
    }
    public getKycStartAccount(id:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`accounts/${id}/kyc`);
    }
    public getSavingPlanPaymentInterval():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'intervals');
    }
    public addSavingPlan(depotId:number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`depots/${depotId}/savings-plan`);
    }
    public updateAddress(addressId:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`addresses/${addressId}`);
    }
    public updateChannel(channelId?:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`contact-channels${channelId?'/'+channelId:''}`);
    }
    public updateSettings(accountId?:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`account-settings/${accountId}`);
    }
    public markPaymentAsDefault(paymentAccountId?:number):string{
        return this.buildUrl(BaseUrls.getPaymentUrl(),`payment-account/${paymentAccountId}/default`);
    }
    public deletePaymentBankAccount(paymentAccountId?:number):string{
        return this.buildUrl(BaseUrls.getPaymentUrl(),`payment-account/${paymentAccountId}`);
    }
    public addPaymentBankAccount():string{
        return this.buildUrl(BaseUrls.getPaymentUrl(),'payment-account/create');
    }
    public getInboxMessages(account_id:number,request:PageRequest):string{
        const queryParams = objectToQueryString(request);
        return this.buildUrl(BaseUrls.getCoreUrl(), `inbox-message?account_id=${account_id}&include=message_text,documents&${queryParams}`);
    }
    public getSingleInboxMessage(messageId: number,account_id:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(), `inbox-message/${messageId}?account_id=${account_id}&include=message_text,documents`);
    }
    public getSupportTickets(request:PageRequest):string{
        const queryParams = objectToQueryString(request);
        const include = "include=creater,contacts,support_status,person_data"
        return this.buildUrl(BaseUrls.getCoreUrl(), `support-tickets?${include}&${queryParams}`);
    }
    public getSupportTicketStatusList(request:PageRequest):string{
        const queryParams = objectToQueryString(request);
        return this.buildUrl(BaseUrls.getCoreUrl(), `support-statuses?${queryParams}`);
    }
    public getSingleSupportTicket(ticketId: number):string{
        const include = SINGLE_SUPPORT_TICKET_INCLUDE
        return this.buildUrl(BaseUrls.getCoreUrl(), `support-tickets/${ticketId}?${include}`);
    }
    public sendMessageForSupportTicket():string{
        const include = SINGLE_SUPPORT_TICKET_INCLUDE
        return this.buildUrl(BaseUrls.getCoreUrl(), `support-messages?${include}`);
    }
    public createSupportTicket():string{
        const include = SINGLE_SUPPORT_TICKET_INCLUDE
        return this.buildUrl(BaseUrls.getCoreUrl(), `support-tickets?${include}`);
    }
    public updateSupportTicketData(ticketId: number):string{
        const include = "include=support_status"
        return this.buildUrl(BaseUrls.getCoreUrl(), `support-tickets/${ticketId}?${include}`);
    }
    public updatePassword():string{
        return this.buildUrl(BaseUrls.getCoreUrl(), `password-update`);
    }
    public updateProfile(contactId: number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(), `contacts/update-avatar/${contactId}`);
    }
    public initTwoFA():string{
        return this.buildUrl(BaseUrls.getCoreUrl(), `mfa/init`);
    }
    public verifyTwoFA():string{
        return this.buildUrl(BaseUrls.getCoreUrl(), `mfa/verify`);
    }
    public disableTwoFA():string{
        return this.buildUrl(BaseUrls.getCoreUrl(), `mfa/reset`);
    }
    public updateDepotAvatar(depotId: number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), `depots/update-avatar/${depotId}`);
    }
    public getOrderPreview():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), 'orders/preview');
    }
    public placeOrder():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), 'orders');
    }
    public confirmOrder():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), 'orders/confirm');
    }
    public getPendingApprovals():string{
        return this.buildUrl(BaseUrls.getCoreUrl(), 'pending-approvals?show_approved=1');
    }
    public getConfirmationMethods():string{
        return this.buildUrl(BaseUrls.getCoreUrl(), 'order-approval-methods');
    }
    public transferAsset():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), 'depots/transfer');
    }
    public confirmTransferOrder():string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), 'depots/transfer/confirm');
    }
    public getTradableAmount(depotId:number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), `depots/${depotId}/tradeable-amount?include=order_transactions,orders_payment_transactions,depot`);
    }
    public detailPaymentAccount(id:number):string{
        return this.buildUrl(BaseUrls.getPaymentUrl(), `payment-account/${id}`);
    }
    public paymentAccounts():string{
        return this.buildUrl(BaseUrls.getPaymentUrl(), `payment-account/user-accounts`);
    }
    public paymentMethods():string{
        return this.buildUrl(BaseUrls.getPaymentUrl(), `payment-methods`);
    }
    public updateDepotInfo(id:number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), `depots/${id}`);
    }
    public updateDepotStatus(depotId: number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), `depots/${depotId}/status`);
    }
    public getGreenStatistics(accountId: number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(), `account/${accountId}/green-stats`);
    }
    public getDepotStatusList(){
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),'depot-statuses');
    }
    public getUpvestAccountInfo(){
        return this.buildUrl(BaseUrls.getTradingUrl(),'trading-account/me');
    }
    public getAccountValuationHistory(upvestAccountId:string,startDate:string,endDate:string,instrumentId:string){
        if(!instrumentId)
            return this.buildUrl(BaseUrls.getTradingUrl(),`trading-account/valuation/${upvestAccountId}/history?start_date=${startDate}&end_date=${endDate}`);
        else
            return this.buildUrl(BaseUrls.getTradingUrl(),`trading-account/valuation/${upvestAccountId}/history?start_date=${startDate}&end_date=${endDate}&instrument_id=${instrumentId}`);
    }
    public getCurrentUpvestAccountValuation(upvestAccountId:string){
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-account/valuation/${upvestAccountId}/current?price_quality=EOD`);
    }
    public getUpvestAccountPositions(upvestAccountId:string){
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-account/position/${upvestAccountId}/all?include=instrument_type,latest_price&order_direction=DESC`);
    }
    public getUpvestAccountOrders(upvestAccountId:string,page:number,per_page:number){
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-order?upvest_account_id=${upvestAccountId}&page=${page}&per_page=${per_page}&include=instrument_type,latest_price&order_direction=DESC`);
    }
    public getUpvestAccountSavingsPlan(upvestAccountId:string){
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-order?upvest_account_id=${upvestAccountId}&page=1&per_page=500&include=instrument_type,latest_price&is_savings_plan=1`);
    }
    public getUpvestOrderTransactions(upvestAccountId:string,page:number,per_page:number){
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-order?upvest_account_id=${upvestAccountId}&page=${page}&per_page=${per_page}&include=instrument_type,latest_price&order_direction=DESC`);
    }
    public getUpvestCashBalance(upvestAccountGroupId:string){
        return this.buildUrl(BaseUrls.getTradingUrl(),`payment/cash-balance/${upvestAccountGroupId}`);
    }
    public getUpvestCashBalanceTransaction(upvestAccountGroupId:string,page:number,per_page:number){
        return this.buildUrl(BaseUrls.getTradingUrl(),`report/transaction/cash?upvest_account_group_id=${upvestAccountGroupId}&page=${page}&per_page=${per_page}&order_direction=DESC`);
    }
    public getUpvestAccountHistory(upvestUserId:string,page:number,per_page:number,startDate:string,endDate:string,type:string):string{
        let path = `report/user/${upvestUserId}?page=${page}&per_page=${10}&order_direction=DESC`;
        if(type)
            path+="&type="+type
        if(startDate)
            path+="&start_date="+startDate;
        if(endDate)
            path+="&end_date="+endDate;
        return this.buildUrl(BaseUrls.getTradingUrl(),path);
    }
    public getUpvestAccountHistoryReport(reportId:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`report/${reportId}?format=pdf`);
    }
    public getSupportedInstruments():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`instruments/supported?include=latest_price,instrument_type`);
    }
    public getPublicInstrumentData(isin:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`instruments/${isin}?include=latest_price,instrument_type`);
    }  
    public getUpvestInstrumentData(isin:string,upvestAccountId:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-account/position/${upvestAccountId}/instrument/${isin}?include=latest_price,instrument_type`);
    }
    public getUpvestConditions(lang:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`document?lang=${lang}&category=conditions,general`);
    }
    public getIntrumentTradingPreview():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),'trading-order/preview');
    }
    public getIntrumentOrderPlacement():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),'trading-order');
    }
    public confirmInstrumentOrder():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),'trading-order/confirm');
    }
    public deleteSavingsPlanLink(upvestSavingPlanId:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-order/saving-plan/${upvestSavingPlanId}`);
    }
    public getTaxExemptions(upvestUserId:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`tax-exemption?upvest_user_id=${upvestUserId}`);
    }
    public createTaxExemptions():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`tax-exemption`);
    }
    public deleteEditTaxExemptions(taxExemptionId:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`tax-exemption/${taxExemptionId}`);
    }
    public getUpvestPaymentAccount(upvestAccountGroupId:string):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`payment/bank-account?upvest_account_group_id=${upvestAccountGroupId}`);
    }
    public upvestInitiateDirectdebit():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`payment/direct-debit`);
    }
    public upvestInitiateDirectdebitConfirm():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`payment/direct-debit/confirm`);
    }
    public upvestWithdrawal():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`payment/withdrawal`);
    }
    public upvestWithdrawalConfirm():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`payment/withdrawal/confirm`);
    }
    public onBoardUser():string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-account/initiate-onboarding-user-process`);
    }
    public getWebidAction(id:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`accounts/${id}/webid-verification`);
    }
    public upvestAccountStatus(userId:number):string{
        return this.buildUrl(BaseUrls.getTradingUrl(),`trading-user/check/${userId}`);
    }
    public getVerifyAddressLink(accountId:number):string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`accounts/${accountId}/poa`);
    }
    public getOrderInvoiceUrl(transactionId:number):string{
        return this.buildUrl(BaseUrls.getGoldDinarUrl(),`transactions/${transactionId}/invoice`);
    }
    public getTicketTypes():string{
        return this.buildUrl(BaseUrls.getCoreUrl(),`support-ticket-types`);
    }
    private buildUrl(baseUrl:string,path:string):string{
        return baseUrl + path;
    }

}